/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { createUseStyles } from 'react-jss';

import styles from './TakeOver.style';

type Props = {
  children: React.Node,
};

const useStyles = createUseStyles(styles);

const TakeOver = ({ children }: Props): React.Node => {
  const classes: Object = useStyles();

  return <div className={classes.root}>{children}</div>;
};

export default compose(React.memo)(TakeOver);
